module.exports = __webpack_public_path__ + "img/eattake-horizontal-colorida.2ca05f50.svg";